import Plyr from 'plyr';
import Player from '@vimeo/player/src/player';

export default () => {
    return {
        player: null,

        mounted(source) {
            if (source === 'vimeo') {
                this.player = new Player(this.$refs.player);
            } else {
                this.player = new Plyr(this.$refs.player, {
                    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
                });
            }
        }
    };
};
